import { Link } from "@mui/material";
import {
  FunctionField,
  RaRecord,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import { getReferenceName } from "../../utils/walletTransactionReference";

const VendorTipMetaShow = (props: any) => {
  return (
    <Show {...props} actions={false}>
      <SimpleShowLayout>
      <TextField source="id" sortable={false} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Cook Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/Cooks/${record?.cookId}/show`}>
                    {record?.cookId}
                </Link>
                );
        }} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Customer Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/Customers/${record?.customerId}/show`}>
                    {record?.customerId}
                </Link>
                );
        }} />
        <TextField source="amount" sortable={false} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Reference Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/${getReferenceName(record?.referenceModelName)}/${record?.referenceId}/show`}>
                    {record?.referenceId}
                </Link>
                );
        }} />
        <TextField source="referenceModelName" sortable={false} />
        <TextField source="status" sortable={false} />
        <TextField source="razorpayOrderId" sortable={false} />
        <TextField source="vendorPayoutTransactionId" sortable={false} />
        <FunctionField label="Created At" render={(record: any) => record?.createdAt ? formatDateTimeWithSeconds(record.createdAt) : '-'} />
        <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? formatDateTimeWithSeconds(record.updatedAt) : '-'} />  
      </SimpleShowLayout>
    </Show>
  );
};

export default VendorTipMetaShow;
